import React from 'react';
import { ToggleBlock } from 'src/components/toggleBlock';

export default function ToggleBlockWrapper({ input, meta, ...rest }) {
  return <ToggleBlock input={input} checked={input.value} {...rest} />;
}
